export default {
  LOGIN_USER(state, { token, email }) {
    state.user.email = email;
    state.user.token = token;
  },

  LOGOUT_USER(state) {
    state.user.token = "";
    state.user.email = "";
  },

  SET_USER(state, user) {
    state.user = user;
  },
  SET_PLAN_RESTRICTIONS(state, planRestrictions) {
    state.planRestrictions = planRestrictions;
  }
};
